module.exports = {
  messages: {
    CN: {
      closeLeft: '关闭左侧',
      closeRight: '关闭右侧',
      closeOthers: '关闭其它',
      refresh: '刷新页面',
      warn: '这是最后一页，不能再关闭了',
    },
    HK: {
      closeLeft: '關閉左側',
      closeRight: '關閉右側',
      closeOthers: '關閉其它',
      refresh: '刷新頁面',
      warn: '這是最後一頁，不能再關閉了',
    },
    US: {
      closeLeft: 'close left',
      closeRight: 'close right',
      closeOthers: 'close others',
      refresh: 'refresh the page',
      warn: 'This is the last page, you can\'t close it',
    },
  }
}